import { SkipToken, skipToken } from '@reduxjs/toolkit/dist/query'

import { Interaction } from 'lib/types/interaction.types'
import { UserRole } from 'lib/types/user.types'

import { useUser } from 'hooks/users'

import { useCoworker } from '../../api.hooks'
import { useInteractions } from './interaction.slice'

export const useInteractionsWrapper = (coworkerId: string | SkipToken) => {
  const role = useUser().data?.role

  const isTl = role === UserRole.TeamLead

  const regularQuery = useInteractions(isTl ? skipToken : coworkerId)
  const teamleadQuery = useCoworker(!isTl ? skipToken : coworkerId)

  if (isTl) {
    const { data, ...coworkerMeta } = teamleadQuery
    const interactions = (data as any)?.interactions as Interaction[] | undefined
    return {
      ...coworkerMeta,
      data: interactions,
      currentData: interactions,
    }
  }

  return regularQuery
}
